import React, { useContext, useState } from "react";
import Select from "react-dropdown-select";
import employerContext from "../../../hooks/employerContext";
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from 'react-redux';
import { IoClose } from 'react-icons/io5';
import { handleGoogleApiLocation, handleInput } from "Actions/commonAction/milleSearchFilterActions";

const CandidateFilterWidget = ({ skillData, initialGlow, mellieSearchSkills, setMellieSearchSkills, handleMellieSearch }) => {
  const { location, enteredInputLocation } = useSelector((state) => state.milleSearchStates)
  const dispatch = useDispatch();

  const { setFilterSkills } = useContext(employerContext);

  const [skillsSearch, setSkillsSearch] = useState(true);

  const handleSkills = (skillsValue) => {
    setMellieSearchSkills(skillsValue)

    if (skillsValue.length > 0) {
      const checkIfValueIsOthers = skillsValue.filter((v) => {
        return v.label === "Others"
      })

      if (checkIfValueIsOthers.length > 0) {
        const ChangeOtherValuesToDisable = skillData.map((skills) => {
          return skills.label !== "Others" ? { ...skills, disabled: true } : skills
        })
        setFilterSkills(ChangeOtherValuesToDisable)
        setSkillsSearch(false)
      } else {
        const ChangeOtherValuesToDisable = skillData.map((skills) => {
          return skills.label === "Others" ? { ...skills, disabled: true } : skills
        })
        setFilterSkills(ChangeOtherValuesToDisable)
        setSkillsSearch(true)
      }
    } else {
      const ChangeDisableFalse = skillData.map((skills) => {
        return { ...skills, disabled: false }
      })
      setFilterSkills(ChangeDisableFalse)
      setSkillsSearch(true)
    }
  }

  return (
    <div className="container">
      <div className="row g-2 p-3 pb-5">
        <div className="col-12">
          <div className="mb-4">
            {initialGlow ?
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
              :
              <>
                <h6 className="fw-bold">Skills</h6>
                <Select
                  multi
                  color="#ffa32d"
                  style={{ fontSize: ".9rem" }}
                  className="rounded-1"
                  options={mellieSearchSkills.length < 5 ? skillData : []}
                  addPlaceholder={skillsSearch ? "Select up to 5 Skills" : ""}
                  onChange={(values) => handleSkills(values)}
                  values={mellieSearchSkills}
                  searchable={skillsSearch}
                />
              </>
            }
          </div>
        </div>

        <div className="col-12">
          <div className="">
            {initialGlow ?
              <>
                <h6 className="placeholder p-2 py-3 w-50 rounded-2"></h6>
                <p className="placeholder p-2 py-3 w-100 rounded-2 mb-0"></p>
              </>
              :
              <div className='mb-0'>
                <h6 className='fw-bold'>Location</h6>
                <div className={location.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                  {location.map((v) => (
                    <div className="col-12 py-1 pe-1">
                      <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                        <div className="col-11">
                          <p className='w-100 mb-0 text-break'>{v}</p>
                        </div>
                        <div className="col-1">
                          <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleGoogleApiLocation({ type: "delete", deletionData: v }))} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <Autocomplete
                  apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                  className='google-places-api'
                  onPlaceSelected={(place) => {
                    if (place) {
                      dispatch(handleGoogleApiLocation({ type: "push", place: place.address_components }))
                    }
                  }}
                  onChange={(e) => dispatch(handleInput({ field: 'location', value: e.target.value }))}
                  value={enteredInputLocation}
                  disabled={location.length === 5}
                />
              </div>
            }
          </div>
        </div>
      </div>

      <div className="w-100">
        <button type="button" className="btn btn-transparent border btn-brand-color candidate-right-side-btn w-100" onClick={() => {
          handleMellieSearch("ApplyFilter")
        }}>Apply Filter</button>

        <button type="button" className="btn btn-transparent border border-brand-color w-100 my-2" onClick={() => {
          handleMellieSearch("clearFilter")
        }}>Clear Filter</button>
      </div>
    </div>
  );
};

export default CandidateFilterWidget;
